import { Navigate } from "react-router-dom";
import { AppRoutes } from "../navigation/AppRoutes";
import { isAdminUser, isTeacherUser } from "../model/Functions";

/** Création de fiches doc (POST / documentations) réservée aux rôles cf-admin et cf-teachers. */
export function TeacherOrAdminRoute({ children }: { children: React.ReactNode }) {
  if (isAdminUser() || isTeacherUser()) {
    return <>{children}</>;
  }
  return <Navigate to={AppRoutes.HOME} replace />;
}
